/**
 * Shared on-screen labels (UI sweep, owner 18 Oct 2026).
 *
 * The people credited on a sale (its commissions) are always "Sales Reps":
 * refund details, sale details, receipt details, chargebacks, event orders
 * and the checkout success page. One place, so no screen drifts again
 * (the refund details said "Sailers").
 */
export const SALES_REPS_LABEL = 'Sales Reps';
